export function setCuentaBanco(state, banco) {
  state.cuentaBanco = banco;
}





